export const STATUS_ACTIVE = 'active'
export const STATUS_NOT_ACTIVE = 'desactive'
export const STATUS_BLOCKED = 'blocke'
export const STATUS_CONTACT = 'contact'
export const STATUS_CLASSIC = 'classic'
